// Full-document render of the Oscar change-password view: PageSkeleton
// wrapping the breadcrumb shell ("Your Account / Change Password") and the
// password form rendered as a native React field tree.
import React from "react";
import { t } from "ttag";

import { templates } from "@reactivated";

import { AccountBreadcrumbShell } from "../components/AccountBreadcrumbShell";
import { AccountForm } from "../components/AccountForm";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.ChangePasswordDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <AccountBreadcrumbShell
            crumbs={[
                { label: t`Your Account`, href: props.profile_url },
                { label: t`Change Password` },
            ]}
            heading={t`Change Password`}
        >
            <AccountForm
                form_id={props.form_id}
                action_url={props.action_url}
                fields={props.fields}
                field_labels={props.field_labels}
                field_errors={props.field_errors}
                non_field_errors={props.non_field_errors}
                submit_text={props.submit_text}
                cancel_text={props.cancel_text}
            />
        </AccountBreadcrumbShell>
    </PageSkeleton>
);
